export enum PriceType {
  tariff,
  offer,
}
